<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class=""><i class="fa fa-building"></i><b>&nsub;Carrier Accounts: Link Carrier Account</b></h5>
                </div>
                <div class="col-3 text-right">
                    <strong class="text-right" style="color:rgb(253, 207,76 );">{{user?.UserName}}</strong>
                </div>
            </div>
            <table class="table table-sm table-striped" style="border-top:none;">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">
                        <th scope="col">Carrier Name</th>
                        <th scope="col">Lead User</th>
                        <th scope="col">Assigned Role</th>
                        <th scope="col">Contact#</th>
                        <th scope="col">Link Status</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tr *ngFor="let acc of carrierAccounts">
                    <td>{{acc.carrier_name}}</td>
                    <td>{{acc.lead_user_name}}</td>
                    <td>{{getRoleDesc(acc.assigned_role)}}</td>
                    <td>{{acc.carrier_contact}}</td>
                    <td>{{acc.link_status}}</td>
                    <td><button class="btn-add btn btn-primary btn-sm" (click)="enterOTP(acc)" [disabled]="acc.link_status != 'Pending'" style="font-size: 12px; height: 30px; width: 80px; border-radius: 15px;">Enter OTP</button></td>
                </tr>
            </table>
        </div>
    </div>
</div>

<button data-toggle="modal" data-target="#OtpModal" id="secretButton" style="display:none"></button>

<div class="modal fade form-group" id="OtpModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Enter verification code</label>
                <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-xl">
                <form>
                    <div class="row test">
                        <div class="col-12 sp-fld">
                            <div class="text-center">
                                <small class="extra-clr ft-c" id="OtpMessage"></small><br/>
                            </div>
                            <input #otpInput placeholder="ENTER OTP HERE" style="width: 99%; padding-left: 8px;" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-block mt-4 mb-4" (click)="confirm(otpInput)">Confirm</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>
